
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.875 23.045l-.655.621-11.283 10.688-8.535-8.848 5.259-21.134A3.283 3.283 0 0028.015.335a24.03 24.03 0 00-21.88 7.643A23.992 23.992 0 00.91 30.545a9.065 9.065 0 006.158 6.216l3.156.933.286.087 8.352 2.486-1.033 4.016-.273 1.085a1.68 1.68 0 001.277 2.073 24.026 24.026 0 0020.197-4.733 23.997 23.997 0 008.968-18.694v-.033a1.243 1.243 0 00-2.124-.936zM24.001 2.78c.807-.006 1.614.034 2.417.12a1.506 1.506 0 011.294 1.857L23.126 23.14 9.254 8.756A21.157 21.157 0 0124.001 2.78zM9.408 34.536a9.036 9.036 0 01-6.366-7.215 21.585 21.585 0 01-.26-3.315A21.089 21.089 0 017.38 10.82l14.95 15.507-2.8 11.213-10.122-3.004zm21.825 9.39c-.353.137-4.976 1.878-9.953 1.128a.606.606 0 01-.547-.755l.83-3.265 4.072 1.206 3.08.911 2.572.763-.054.012zm3.757-1.802l-3.973-1.177-8.816-2.615 2.405-9.643 7.323 7.575 1.929 2.002 2.704 2.805c-.51.369-1.033.73-1.572 1.053zm9.434-12.374a21.21 21.21 0 01-5.735 9.531l-2.82-2.926 7.597-7.181a.58.58 0 01.958.576z","fill":"url(#paint0_linear_876_11123)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_876_11123","x1":"56.727","y1":"0","x2":"8.786","y2":"-2.14","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#8EC5FC"}}),_c('stop',{attrs:{"offset":".583","stop-color":"#E0C3FC"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#FAE69F"}})])])])
          )
        }
      }
    